export const usePreview = (routeQueryParam?: Record<string, any>) => {
    // Prefer an injected `routeQueryParam` (from middleware) to avoid calling `useRoute`
    // inside middleware. If not provided, fall back to `useRoute()` (client-side).
    // If a routeQueryParam was provided (including an empty object), use it directly.
    // Only call `useRoute()` when no param was supplied at all.
    let routeQuery: Record<string, any>
    if (routeQueryParam !== undefined && routeQueryParam !== null) {
        routeQuery = routeQueryParam
    } else {
        const route = useRoute()
        routeQuery = route.query ?? {}
    }

    const previewToken = ref((routeQuery as any).token || null)

    // https://github.com/craftcms/cms/issues/18337#issuecomment-3819651436
    const livePreviewToken = ref(
        (routeQuery as any)['x-craft-preview'] || (routeQuery as any)['x-craft-live-preview'] || null,
    )
    const previewTimestamp = ref(Date.now())

    const isPreview = computed(() => {
        return !!livePreviewToken.value
    })

    // Update timestamp when preview changes
    const refreshPreview = () => {
        previewTimestamp.value = Date.now()
    }

    return {
        isPreview,
        previewToken,
        livePreviewToken,
        previewTimestamp,
        refreshPreview,
    }
}
